/**
 * Wisecure Design System — Typography Tokens
 *
 * Mirrors the Flutter DS typography (packages/presentation/design_system/lib/typography.dart).
 * Font: Inter
 */

export const fontFamily = "'Inter', system-ui, -apple-system, sans-serif";

export const fontSize = {
  overline: 10,
  caption: 12,
  bodySm: 14,
  bodyMd: 16,
  bodyLg: 16,
  h3: 20,
  h2: 20,
  h1: 24,
  hero: 32,
} as const;

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;

export const lineHeight = {
  tight: 1.25,
  normal: 1.5,
  relaxed: 1.75,
} as const;

export const letterSpacing = {
  tight: '-0.5px',
  normal: '0px',
  wide: '1px',
} as const;
